import React from 'react';
import { Box, Fab } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const SendFloatingAction = ({ isBusy, onSend }) => {
  return (
    <Fab
      color="primary"
      onClick={onSend}
      disabled={isBusy}
      sx={{
        position: 'fixed',
        bottom: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 24, md: 48 },
        zIndex: (theme) => (theme?.zIndex?.modal || 1300) + 200,
      }}
      aria-label="Send Selection"
    >
      {isBusy ? (
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: 24,
            height: 24,
            border: '2px solid',
            borderColor: 'currentColor',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }}
        />
      ) : (
        <SendIcon />
      )}
    </Fab>
  );
};

export default SendFloatingAction;
